// src/services/officialDocsService.js
import { fetchWithAuth } from "../utils/fetchWithAuth";

const DEFAULTS = {
  docsMenuEnabled: false,
  showPublicAccount: false,
  showEstatutos: false,
  showCodigoEtica: false,
  showModeloPrevencion: false,
  showReglamentoInterno: false,
  showProtocolos: false,
  showAnnualReports: false,
  showMaterialInteres: false,
  showPopups: false,
};

const ALLOWED_KEYS = Object.keys(DEFAULTS);

function sanitizeOfficialDocsPayload(p = {}) {
  const out = {};
  for (const k of ALLOWED_KEYS) {
    if (p[k] !== undefined) out[k] = !!p[k]; // asegurar booleanos
  }
  return out;
}

export async function getOfficialDocsConfig() {
  const r = await fetchWithAuth(`/official-docs/config`, { method: "GET" });
  if (!r.ok) throw new Error(await r.text());
  const data = await r.json();
  // Mezcla con defaults y omite cualquier basura extra que venga del backend
  const clean = sanitizeOfficialDocsPayload({ ...DEFAULTS, ...data });
  return clean;
}

export async function updateOfficialDocsConfig(payload) {
  const body = sanitizeOfficialDocsPayload(payload); // 🔧 evita enviar updatedAt, etc.
  const r = await fetchWithAuth(`/official-docs/config`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error(await r.text());
  const saved = await r.json();
  // devolver limpio también
  return sanitizeOfficialDocsPayload({ ...DEFAULTS, ...saved });
}
